import React from "react";
import get from "lodash/get";
import { StoryCard, StoryCardSimple, StoryCardBgImage } from "../basic/story-card.js"
import { Carousel } from '../basic/carousel.js'
import { wrapCollectionLayout } from "@quintype/components";
import { Link } from "@quintype/components";
import "./two-col-carousel.module.css";
import { SectionName } from "../basic/section-name.js";
import {collectionSection} from '../collection-templates/collection-layout-helper';
import {getNumberOfStoriesToShow} from "../../utils";

function CarouselTemplate({story}) {
  return <StoryCard story={story} config={{ image: true, imageAspectRatio: [16,9] }} />
}

function TwoColCarouselBase({ stories = [], associatedMetadata ={}, metadata = {} , collection = {}, config = {}}) {
  const configClone = Object.assign({}, config, { image: true, imageAspectRatio: [16, 9] });
  const configCloneForBgImg = Object.assign({}, config, { image: true, imageAspectRatio: [4,3]});
  const cardStoryCount = 2;
  const originalStoryCount = stories.length;
  if(originalStoryCount < 3) {
    return <div data-comment="At least three stories required for a TwoColCarousel"></div>
  }

  let carouselStoryCount = getNumberOfStoriesToShow(metadata.numberOfStoriesInCarousel);
  if(originalStoryCount < carouselStoryCount + cardStoryCount) {
    carouselStoryCount = originalStoryCount - cardStoryCount;
  }
   const  {'show_collection_title': collectionName = true} = associatedMetadata;

  return (
    <div styleName="wrapper">
    <div styleName="collection-name-wrapper">
     {collectionName ? <SectionName name={collection.name} type="large" section={collectionSection(config, collection)}/> : null}
     </div>
    <div styleName="container">
      <div styleName="carousel fix-height">
        <Carousel stories={stories.slice(0, carouselStoryCount)}
                  limit={carouselStoryCount}
                  infinite={carouselStoryCount > 1}
                  itemTemplate={CarouselTemplate}
                  dots={false}
                  config={config}
                  collection={collection}
                  arrows={ carouselStoryCount > 1 ? true : false }
                  autoplay={metadata.scrollSpeedMs != 0}
                  associatedMetadata={associatedMetadata}
                  autoplaySpeed={metadata.scrollSpeedMs}
                  rtl={get(config, ['theme-attributes','language_direction']) === 'right'}
        />
      </div>
      
      <div styleName={`story-with-card fix-height`}>
        <Link href={`/${stories[carouselStoryCount].slug}`} className="story-card-link">
          <StoryCardSimple config={configClone} story={stories[carouselStoryCount]}  hideAuthor={true} sectionInlineStyle={{ border: 'none'}} widths={[250,480,640]} sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 23%"/>
        </Link>
      </div>
      
      
      <div styleName={`story-on-image fix-height`}>
        <Link href={`/${stories[carouselStoryCount + 1].slug}`} className="story-card-link">
          <StoryCardBgImage story={stories[carouselStoryCount + 1]} hideAuthor={true} config={configCloneForBgImg} sectionInlineStyle={{ border: 'none' }}  widths={[250,480,640]} sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 23%"/>
        </Link>
      </div>    
    </div>
    </div>
  )

}

export const TwoColCarousel = wrapCollectionLayout(TwoColCarouselBase);
